import { render, staticRenderFns } from "./Blocks2.vue?vue&type=template&id=09d1989e"
import script from "./Blocks2.vue?vue&type=script&lang=js"
export * from "./Blocks2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports